export default __webpack_public_path__ + "static/media/common.17b037dd.jpg";